import { PackageIcon, TruckDeliveryIcon } from 'assets'
import { ClientGoalItem } from 'components/client/ClientGoalItem'
import React from 'react'
import { colors } from 'styles/colors'
import { ProcessedGoalItem } from './helpers/villageClientPacketHelpers'

export type ClientOrderStatus = 'unfinished' | 'finished' | 'delivered'

const bannerModifier: Record<ClientOrderStatus, string> = {
    unfinished: '',
    finished: '--finished',
    delivered: '--delivered'
}

const statusColor: Record<ClientOrderStatus, string> = {
    unfinished: colors.primary,
    finished: colors.purple,
    delivered: colors.brown
}

export const ClientOrder = ({
    goalItems,
    status,
    displayDate,
    canUpdatePackage,
    modifyHandler,
    t
}: {
    goalItems: ProcessedGoalItem[]
    status: ClientOrderStatus
    displayDate?: string | null
    canUpdatePackage: boolean
    modifyHandler: () => void
    t: (key: string, values?: { [key: string]: string | number }) => string
}) => {
    const isDelivered = status === 'delivered'
    const className = `client-goal-items-banner${bannerModifier[status]}`

    return (
        <div aria-label="goal-items-section">
            <div className={className}>
                {isDelivered
                    ? PackageIcon({ color: colors.brown })
                    : TruckDeliveryIcon({
                          color:
                              status === 'finished'
                                  ? colors.purple
                                  : colors.grey
                      })}
                <p
                    className={`scheduled-delivery-date${
                        displayDate ? '' : ' scheduled-delivery-date--unavailable'
                    }`}
                >
                    {displayDate
                        ? t('fullDateMonthYear', {
                              date: new Date(displayDate) as unknown as string
                          })
                        : t('clientDetails.noDeliveryDate')}
                </p>
            </div>
            <div className="goal-items-grid">
                {goalItems.map((goalItem, index) => (
                    <div
                        key={index}
                        className={`goal-item${
                            index === goalItems.length - 1 &&
                            goalItems.length % 2 !== 0
                                ? '-center'
                                : ''
                        }`}
                        onClick={
                            canUpdatePackage && !isDelivered
                                ? modifyHandler
                                : () => {}
                        }
                    >
                        <ClientGoalItem
                            goalItem={goalItem}
                            color={statusColor[status]}
                            finished={goalItem.finished}
                            finishedIndicatorVariant={
                                status === 'delivered' ? 'delivered' : 'finished'
                            }
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
